import { supabaseClient } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";

export interface DiaryLabelOption {
    label_id: string;
    label_name: string;
}

export async function fetchDistinctDiaryLabels(): Promise<DiaryLabelOption[]> {
    const { data, error } = await supabaseClient.rpc("get_distinct_diary_labels");

    if (error) throw error;
    return (data ?? []) as DiaryLabelOption[];
}

export const distinctDiaryLabelsQueryKey = ["distinct-diary-labels"];

export function useSelectDistinctDiaryLabels() {
    return useQuery({
        queryKey: distinctDiaryLabelsQueryKey,
        queryFn: fetchDistinctDiaryLabels,
    });
}
